<template>
  <v-layout class="payroll-shell">
    <PayrollSidebar v-model="drawer" />

    <v-main>
      <v-app-bar
        flat
        border
        class="px-2"
      >
        <v-btn
          icon="mdi-menu"
          variant="text"
          @click="drawer = !drawer"
        />

        <div class="ml-2">
          <div class="text-subtitle-1 font-weight-bold">
            Payroll & HR
          </div>
        </div>

        <v-spacer />

        <v-btn
          icon="mdi-file-upload-outline"
          variant="text"
          :to="{ name: 'PayrollCsvImport' }"
        />
        <v-btn
          icon="mdi-bell-outline"
          variant="text"
        />
      </v-app-bar>

      <div class="payroll-content">
        <router-view />
      </div>
    </v-main>
  </v-layout>
</template>

<script setup>
import { ref } from "vue"
import PayrollSidebar from "./PayrollSidebar.vue"

const drawer = ref(true)
</script>

<style scoped>
.payroll-shell {
  min-height: 100vh;
  background:
    radial-gradient(circle at top right, rgba(37, 99, 235, 0.04), transparent 30%),
    rgb(var(--v-theme-background));
}

.payroll-content {
  padding: 22px;
  max-width: 1900px;
  margin: 0 auto;
}

@media (max-width: 600px) {
  .payroll-content {
    padding: 12px;
  }
}
</style>
